module.exports = __webpack_public_path__ + "static/media/Energie_PictoCdlT.30323354.png";